/**
 * Created by Jie Gao on 3/20/2019.
 */

import {AvalancheParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/avalanchereel/AvalancheParsedServerData";
import {DragonTribeServerDataParser} from "../DragonTribeServerDataParser";
import {IDragonTribeGameData} from "./IDragonTribeServerData";
import {DragonTribeGameConfig} from "../../DragonTribeGameConfig";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";

export class DragonTribeParsedGameData extends AvalancheParsedGameData  {
    private readonly _evaluatedArea: string[][];
    private readonly _numberOfWaysWon: number;
    private readonly _avalancheCountThisRoundAfter: number;
    private readonly _avalancheCountThisRoundBefore: number;
    private readonly _gameAreaSize: number[];
    private readonly _gameSizeEnteringFreespin: number[];
    private readonly _actualReelSize: number[];
    private readonly _wildMultipliers: number[];
    private readonly _totalNumberOfWays: number;
    private readonly _wildOnReel: boolean[];
    private readonly _mysterySymbolOnReel:boolean[];
    private readonly _mysterySymbolPositions:number[];
    private readonly _mysterySymbolRevealed:string;
    private readonly _mysterySymbolSize:number[];
    private readonly _xWaysSymbolMayGiveWin:boolean;
    private readonly _avalancheTotalWin:number;
    private readonly _currentAvalancheWinRatio:number;
    private readonly _numberOfScattersBefore:number;
    private readonly _currentAvalancheWinRatioConfig:IWinRatioConfig | null;
    private readonly _playerFSSelection:number;
    private readonly _xWaysSymbolMayGiveWinPositions:boolean[][];

    //bigwin
    private readonly _accumulatedRoundWin:string;
    private readonly _currentBigWinWinRatio:number;
    private readonly _isEndBigWin:boolean;

    constructor(rawData: IDragonTribeGameData, dataParser: DragonTribeServerDataParser) {
        super(rawData, dataParser);

        this._gameAreaSize = ((rawData.mode.indexOf("_")>-1)?rawData.gameAreaSize:[4,4,4,4,4,4]);
        this._gameSizeEnteringFreespin = rawData.gameSizeEnteringFreespin;
        this._actualReelSize = rawData.gameAreaSize;
        this._wildMultipliers = rawData.wildMultipliers;
        this._evaluatedArea = rawData.evaluatedArea;
        this._playerFSSelection = rawData.playerFSSelection;
        this._totalNumberOfWays = rawData.totalNumberOfWays;
        this._wildOnReel = rawData.wildOnReel;
        this._numberOfWaysWon = rawData.numberOfWaysWon;
        this._numberOfScattersBefore = rawData.numberOfScattersBefore;
        this._avalancheCountThisRoundAfter = rawData.avalancheCountThisRoundAfter;
        this._avalancheCountThisRoundBefore = rawData.avalancheCountThisRoundBefore;
        this._mysterySymbolOnReel = dataParser.parseMysterySymbolOnReel(rawData);
        this._mysterySymbolPositions = dataParser.parseMysterySymbolPositions(rawData);
        this._mysterySymbolRevealed = dataParser.parseMysterySymbolRevealed(rawData);
        this._mysterySymbolSize = dataParser.parseMysterySymbolSize(rawData);
        this._xWaysSymbolMayGiveWin = dataParser.parseXWaysSymbolMayGiveWin(rawData);
        this._avalancheTotalWin = dataParser.parseAvalancheTotalWin(rawData);
        this._xWaysSymbolMayGiveWinPositions = rawData.xWaysSymbolMayGiveWinPositions;

        //bigwin
        this._currentBigWinWinRatio = this._avalancheTotalWin / Number(rawData.playedBetValue);
        this._isEndBigWin = this._currentBigWinWinRatio >= DragonTribeGameConfig.instance.WIN_RATIOS.bigWin[0].ratio;
        this._currentAvalancheWinRatio = this._avalancheTotalWin / Number(rawData.playedBetValue);
        this._currentAvalancheWinRatioConfig = DragonTribeParsedGameData.getAvalancheWinRatioConfig(this._currentAvalancheWinRatio);

        this._accumulatedRoundWin = rawData.accumulatedRoundWin;
    }

    private static getAvalancheWinRatioConfig(winRatio:number):IWinRatioConfig | null {
        let winLevels:IWinRatioConfig[] = GameConfig.instance.WIN_RATIOS.normalWin.concat();
        winLevels = winLevels.concat(GameConfig.instance.WIN_RATIOS.bigWin);

        for(let i:number = winLevels.length - 1; i >= 0; i--) {
            const winLevel = winLevels[i];
            if(winRatio >= winLevel.ratio) {
                return winLevel;
            }
        }
        return null;
    }

    public get numberOfScattersBefore(): number {
        return this._numberOfScattersBefore;
    }

    public get currentAvalancheWinRatio(): number {
        return this._currentAvalancheWinRatio;
    }

    public get currentAvalancheWinRatioConfig(): IWinRatioConfig | null {
        return this._currentAvalancheWinRatioConfig;
    }

    public get avalancheTotalWin(): number {
        return this._avalancheTotalWin;
    }

    public get currentBigWinWinRatio(): number {
        return this._currentBigWinWinRatio;
    }

    public get isEndBigWin(): boolean {
        return this._isEndBigWin;
    }

    public get evaluatedArea(): string[][] {
        return this._evaluatedArea;
    }

    public get wildMultipliers(): number[] {
        return this._wildMultipliers;
    }

    public get gameAreaSize(): number[] {
        return this._gameAreaSize;
    }

    public get gameSizeEnteringFreespin(): number[] {
        return this._gameSizeEnteringFreespin;
    }

    public get actualReelSize(): number[] {
        return this._actualReelSize;
    }

    public get totalNumberOfWays(): number {
        return this._totalNumberOfWays;
    }

    public get wildOnReel(): boolean[] {
        return this._wildOnReel;
    }

    public get xWaysSymbolMayGiveWinPositions(): boolean[][] {
        return this._xWaysSymbolMayGiveWinPositions;
    }

    public get numberOfWaysWon(): number {
        return this._numberOfWaysWon;
    }

    public get avalancheCountThisRoundAfter(): number {
        return this._avalancheCountThisRoundAfter;
    }

    public get avalancheCountThisRoundBefore(): number {
        return this._avalancheCountThisRoundBefore;
    }

    public get mysterySymbolOnReel():boolean[] {
        return this._mysterySymbolOnReel;
    }

    public get mysterySymbolPositions():number[] {
        return this._mysterySymbolPositions;
    }

    public get mysterySymbolRevealed():string {
        return this._mysterySymbolRevealed;
    }

    public get mysterySymbolSize():number[] {
        return this._mysterySymbolSize;
    }

    public get xWaysSymbolMayGiveWin():boolean {
        return this._xWaysSymbolMayGiveWin;
    }

    public get playerFSSelection():number {
        return this._playerFSSelection;
    }

    get accumulatedRoundWin(): string {
        return this._accumulatedRoundWin;
    }
}